let Orderable = mc.widgets.Orderable;
let IconButton = mc.widgets.IconButton;
let FormRange = mc.widgets.FormRange;

let MultipleChoiceValues = function (props) {
  let { values, disabled } = props;

  let vals = [].concat(values);

  while (vals.length < 2) {
    vals.push("");
  };

  let onChange = function (i, evt) {
    let val = evt.target.value;

    if (val.indexOf(";") === -1) {
      vals[i] = evt.target.value;

      props.onEdit(vals);
    }
  };

  let onMinus = function (i, evt) {
    vals.splice(i, 1);

    props.onEdit(vals);
  };

  let onPlus = function (evt) {
    vals.push("");

    props.onEdit(vals);
  };

  return vals.map(function (val, i) {
    return (
      <div key={i}>
        <span>{(i + 1) + "."}</span>
        <input
          type="text"
          value={val}
          size="25"
          maxLength="64"
          disabled={disabled}
          onChange={onChange.bind(this, i)}/>
          {i === vals.length - 1 ? (
            <span>
              <IconButton
                icon="minus"
                display="icon"
                scale={0.8}
                onPress={onMinus.bind(this, i)}
                disabled={disabled || i < 2}/>
              <IconButton
                icon="plus"
                display="icon"
                scale={0.8}
                onPress={onPlus}
                disabled={disabled || vals.length >= 10}/>
            </span>
          ) : null}
      </div>
    );
  });
};

let RangeValues = function (props) {
  let onChange = function (idx, value) {
    let { values } = props;

    values[idx] = value;

    props.onEdit(values);
  };

  return (
    <div>
      <span>{tx("min") + ":"}</span>
      <FormRange
        min={0}
        max={100}
        value={props.values[0]}
        onChange={onChange.bind(this, 0)}
        disabled={props.disabled}/>
      <span>{tx("max") + ":"}</span>
      <FormRange
        min={1}
        max={100}
        value={props.values[1]}
        onChange={onChange.bind(this, 1)}
        disabled={props.disabled}/>
    </div>
  );
};

let SliderValues = function (props) {
  let onChange = function (idx, evt) {
    let { values } = props;

    values[idx] = evt.target.value;

    props.onEdit(values);
  };

  return (
    <div>
      <span>{tx("left_label") + ":"}</span>
      <input
        type="text"
        size="12"
        maxLength="64"
        value={props.values[0]}
        onChange={onChange.bind(this, 0)}
        disabled={props.disabled}/>
      <span>{tx("right_label") + ":"}</span>
      <input
        type="text"
        size="12"
        maxLength="64"
        value={props.values[1]}
        onChange={onChange.bind(this, 1)}
        disabled={props.disabled}/>
    </div>
  );
};

class Question extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      memory: {
        "BOOLEAN": ["YES", "NO"],
        "NUMERIC": [],
        "RANGE": [0, 10],
        "SLIDER": ["", ""],
        "TIMEOFDAY": [],
        "MULTIPLECHOICE": [],
        "OPTIONS": [],
        "FREETEXT": [],
        "DATE": [],
        "DURATION": []
      }
    };
  }

  setText(evt) {
    let { question, onEdit } = this.props;

    question.text = evt.target.value;

    onEdit(question);
  }

  setType(evt) {
    let { question, onEdit } = this.props;
    let { memory } = this.state;

    // remember last
    memory[question.type] = question.values;

    question.type = evt.target.value;
    question.values = memory[question.type];

    onEdit(question);
  }

  setValues(values) {
    let { question, onEdit } = this.props;

    question.values = values;

    onEdit(question);
  }

  get ValueFields() {
    let { question } = this.props;

    switch (question.type) {
      case "MULTIPLECHOICE":
      case "OPTIONS":
        return MultipleChoiceValues;
      case "RANGE":
        return RangeValues;
      case "SLIDER":
        return SliderValues;
      default:
        return null;
    }
  }

  render() {
    let {
      question,
      questionMaxLength,
      types,
      labels,
      fieldSize,
      disabled,
      onDelete
    } = this.props;

    let width = Math.max(labels[0].length, labels[1].length) * 15;

    return (
      <div className="rc-question">
        <div className="rc-question-q">
          <span className="rc-question-label" style={{ width }}>
            {labels[0] + ":"}
          </span>
          <input
            type="text"
            value={question.text}
            onChange={this.setText.bind(this)}
            size={fieldSize}
            maxLength={questionMaxLength}
            disabled={disabled}/>
          <IconButton
            icon="minus"
            display="icon"
            onPress={onDelete.bind(this)}
            disabled={disabled}/>
        </div>
        <div className="rc-question-a">
          <span className="rc-question-label" style={{ width }}>
            {labels[1] + ":"}
          </span>
          <select onChange={this.setType.bind(this)} value={question.type} disabled={disabled}>
            {types.map(function (type) {
              return (
                <option key={type} value={type}>
                  {tx("question." + type)}
                </option>
              );
            })}
          </select>
        </div>
        {this.ValueFields ? (
          <div className="rc-question-values">
            <this.ValueFields
              values={question.values}
              onEdit={this.setValues.bind(this)}
              disabled={disabled}/>
          </div>
        ) : null}
      </div>
    );
  }
}

let QuestionEditor = function (props) {
  let {
    questions,
    questionMaxLength,
    types,
    labels,
    fieldSize,
    onEdit,
    disabled
  } = props;

  if (!types) {
    types = [
      // "DATE",
      "BOOLEAN",
      "NUMERIC",
      "RANGE",
      "SLIDER",
      "TIMEOFDAY",
      "DURATION",
      "MULTIPLECHOICE",
      "OPTIONS",
      "FREETEXT"
    ];
  }

  if (!labels) {
    labels = ["Q", "A", tx("add_question")];
  }

  if (!fieldSize) {
    fieldSize = 50;
  }

  let orderQuestions = function (order) {
    if (!disabled) {
      let ordered = order.map(function (orderId) {
        return questions.find((q) => q.orderId === orderId);
      });

      onEdit(ordered);
    }
  };

  let addQuestion = function () {
    let type = types[0];

    questions.push({
      text: "",
      orderId: Date.now(),
      type,
      values: { "BOOLEAN": ["YES", "NO"], "RANGE": [0, 10] }[type] || []
    });

    onEdit(questions);
  };

  let deleteQuestion = function (idx) {
    questions.splice(idx, 1);

    onEdit(questions);
  };

  let editQuestion = function (idx, question) {
    questions[idx] = question;

    onEdit(questions);
  };

  let rows = questions.map(function (question, i) {
    if (question.orderId === undefined) {
      question.orderId = i;
    }

    return (
      <Question
        key={question.orderId}
        orderId={question.orderId}
        question={question}
        questionMaxLength={questionMaxLength}
        onEdit={editQuestion.bind(this, i)}
        onDelete={deleteQuestion.bind(this, i)}
        types={types}
        labels={labels}
        fieldSize={fieldSize}
        disabled={disabled}/>
    );
  });

  return (
    <div>
      <Orderable onOrder={orderQuestions}>
        {rows}
      </Orderable>
      <IconButton
        icon="plus"
        label={labels[2]}
        display="text"
        onPress={addQuestion}
        disabled={disabled}/>
    </div>
  );
};

QuestionEditor.defaultProps = {
  questionMaxLength: 1024
};

module.exports = QuestionEditor;
